import { toast } from "react-toastify";
import {
    CANDIDATE_ORIGINS_OPTIONS,
    CANDIDATE_ORIGIN_APPROVE_STATUS_OPTIONS,
    CANDIDATE_INPUT_INFO_TYPES,
    LOCAL_STORAGE_USER_LOGIN_INFO
} from "@app/constants/Common";
import * as CandidateService from "@app/services/CandidateService";
import { showSuccessMessageSaveData } from "@pages/candidate/Common";
import AllUserInputField from "@pages/candidate/commonview/AllUserInputField";
import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import {capitalizeName} from "@app/utils/CommonUtils";
import DobInputGroup from "@pages/candidate/detail/DobInputGroup";
import { searchAllInputInfo } from "@app/services/CandidateService";
import {cloneDeep} from "lodash";
import { showMessage } from "@app/constants/Messages";
import { validateDMYInput } from "@pages/dvtjcuv/common/ValidateUtils";
import { checkExistsCommonFieldValues } from "@app/utils/CandidateUtils";

const CandidatePersonalInfo = (props) => {
    const [personal, setPersonal] = useState({});
    const [isEdit, setIsEdit] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [userLoginInfo, setUserLoginInfo] = React.useState({});
    const [allPersonalInfo, setAllPersonalInfo] = React.useState([]);

    const {
        candidateId,
        // allInputInfo,
        isEditPersonal = false,
        mode = 'Edit',
        onChange
    } = props

    const fetchPersonal = async (canId) => {
        setIsLoading(true)
        CandidateService.getCandidatePersonalDetail(canId).then((res) => {
            setPersonal(res.content)
        }).catch((error) => {
            // toast.error(`Có lỗi xảy ra trong quá trình xử lý.`);
        }).finally(() => {
            setIsLoading(false)
        });
        const allInfo = await searchAllInputInfo(canId, CANDIDATE_INPUT_INFO_TYPES.Personal)
        setAllPersonalInfo(cloneDeep(allInfo))
    };

    useEffect(() => {
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            setUserLoginInfo(JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)))
        }

        fetchPersonal(candidateId);
    }, [])

    useEffect(() => {
        fetchPersonal(candidateId);
    }, [candidateId]);


    const updateCandidatePersonal = (fields, type) => {
        // Check xem trong số các trường sử dụng chung, giá trị đã đc nhập bởi user khác cho UV này chưa
        // Nếu có user khác nhập cho UV này giá trị rồi => báo lỗi, ko save thông tin vào DB.
        personal.allPersonalInfo = allPersonalInfo
        if (checkExistsCommonFieldValues(personal, userLoginInfo.id)) {
            return;
        }

        if (!validateDMYInput(personal.paper_dob, personal.paper_mob, personal.paper_yob)) {
            showMessage(`DOB giấy tờ không hợp lệ.`);
            return;
        }
        if (!validateDMYInput(personal.actual_dob, personal.actual_mob, personal.actual_yob)) {
            showMessage(`DOB thực tế không hợp lệ.`);
            return;
        }
        // setIsLoading(true)
        let payload = {...personal}
        // TODO: Will set user login name
        // if (!payload['vocative']) {
        //     payload['vocative'] = userLoginInfo.name
        // }
        // fields.forEach(field => {
        //     payload[field] = personal[field]
        //     // TODO: Will set user login name
        //     if (field === 'vocative' && !payload[field]) {
        //         payload[field] = DEFAULT_ADMIN_NAME
        //     }
        // })
        CandidateService.updateCandidatePersonalDetail({candidate_id: candidateId, personal: payload}).then((res) => {
            console.log(JSON.stringify(res))
            showSuccessMessageSaveData(res.sts_code)
            setIsEdit(false)
        }).catch((error) => {
            toast.error(`Có lỗi xảy ra trong quá trình xử lý.`);
        }).finally(() => {
            // setIsLoading(false)
        });
    };

    const onChangePersonalInput = (event) => {
        // if (event.target.name === 'gender') {
        //     if (event.target.value === 'nam') {
        //         personal.caller_name_to_email = 'anh';
        //     } else if (event.target.value === 'nữ') {
        //         personal.caller_name_to_email = 'chị';
        //     } else {
        //         personal.caller_name_to_email = '';
        //     }
        // }
        personal[event.target.name] = event.target.value
        setPersonal({...personal})
    }


    return (
        <>
            <div className='card card-default'>
                <div className='card-header'>
                    <h3 className='card-title text-bold'>Thông tin cơ bản</h3>
                    <div className='card-tools'>
                        {isEdit &&
                            <button type='button'
                                    className='btn btn-default mr-2'
                                    onClick={() => {
                                        setIsEdit(false);
                                    }}
                            >
                                Cancel
                            </button>
                        }
                        {isEdit &&
                            <button type='button'
                                    className='btn btn-primary'
                                    onClick={() => {
                                        updateCandidatePersonal(['full_name', 'last_name', 'vn_name', 'foreign_name', 'email_name', 'appearence']);
                                    }}
                            >
                                Save
                            </button>
                        }
                        {!isEdit &&
                            <button type='button'
                                    className='btn btn-default'
                                    onClick={() => {
                                        setIsEdit(true);
                                    }}
                            >
                                Edit
                            </button>
                        }
                    </div>
                </div>
                <div className='card-body'>
                    <div className='input-group'>
                        <label className={'w-100'}>Họ & tên</label>
                        <input type='text' className='form-control'
                                disabled={!isEdit}
                                value={personal.full_name ? capitalizeName(personal.full_name) : ''}
                                name={'full_name'}
                                onChange={event => onChangePersonalInput(event)}/>
                        <AllUserInputField arrInfo={allPersonalInfo}
                                            field='full_name'/>
                    </div>
                    <div className='input-group'>
                        <label className={'w-100'}>Họ</label>
                        <input type='text' className='form-control'
                                disabled={!isEdit}
                                value={personal.last_name ? capitalizeName(personal.last_name) : ''}
                                name={'last_name'}
                                onChange={event => onChangePersonalInput(event)}/>
                        <AllUserInputField arrInfo={allPersonalInfo}
                                            field='last_name'/>
                    </div>
                    <div className='input-group'>
                        <label className={'w-100'}>Tên VN</label>
                        <input type='text' className='form-control'
                                disabled={!isEdit}
                                value={personal.vn_name ? capitalizeName(personal.vn_name) : ''}
                                name={'vn_name'}
                                onChange={event => onChangePersonalInput(event)}/>
                        <AllUserInputField arrInfo={allPersonalInfo}
                                            field='vn_name'/>
                    </div>
                    <div className='input-group'>
                        <label className={'w-100'}>Tên nước ngoài</label>
                        <input type='text' className='form-control'
                                disabled={!isEdit}
                                value={personal.foreign_name ? capitalizeName(personal.foreign_name) : ''}
                                name={'foreign_name'}
                                onChange={event => onChangePersonalInput(event)}/>
                        <AllUserInputField arrInfo={allPersonalInfo}
                                            field='foreign_name'/>
                    </div>
                    <div className='input-group'>
                        <label className={'w-100'}>Tên (Email)</label>
                        <input type='text' className='form-control'
                                disabled={!isEdit}
                                value={personal.email_name ? capitalizeName(personal.email_name) : ''}
                                name={'email_name'}
                                onChange={event => onChangePersonalInput(event)}/>
                        <AllUserInputField arrInfo={allPersonalInfo}
                                            field='email_name'/>
                    </div>
                    <DobInputGroup
                        label={'DOB Giấy tờ'}
                        dayName={'paper_dob'}
                        monthName={'paper_mob'}
                        yearName={'paper_yob'}
                        values={personal}
                        dbInfo={''}
                        isDisabled={!isEdit}
                        onChange={event => onChangePersonalInput(event)}
                        allInputInfo={allPersonalInfo}
                    />
                    <DobInputGroup
                        label={'DOB thực tế'}
                        dayName={'actual_dob'}
                        monthName={'actual_mob'}
                        yearName={'actual_yob'}
                        values={personal}
                        dbInfo={''}
                        isDisabled={!isEdit}
                                        onChange={event => onChangePersonalInput(event)}
                        allInputInfo={allPersonalInfo}
                    />
                    <div className='input-group mt-3'>
                        <label className={'w-100'}><b>Tuổi dự đoán</b></label>
                        <input type='number' className={`form-control`}
                                disabled={!isEdit}
                                value={personal.guess_age}
                                name={'guess_age'}
                                onChange={event => onChangePersonalInput(event)}/>
                        <AllUserInputField arrInfo={allPersonalInfo}
                                            field='guess_age'/>
                    </div>
                    <div className='input-group mt-3'>
                        <label className={'w-100'}><b>Ngoại hình</b></label>
                        <input type='text' className={`form-control`}
                                disabled={!isEdit}
                                value={personal.appearence}
                                name={'appearence'}
                                onChange={event => onChangePersonalInput(event)}/>
                        <AllUserInputField arrInfo={allPersonalInfo}
                                            field='appearence'/>
                    </div>
                    <div className='input-group mt-3'>
                        <label className={'w-100'}><b>Note Thông tin cá nhân</b></label>
                        <input type='text' className={`form-control`}
                                disabled={!isEdit}
                                value={personal.personal_note}
                                name={'personal_note'}
                                onChange={event => onChangePersonalInput(event)}/>
                        <AllUserInputField arrInfo={allPersonalInfo}
                                            field='personal_note'/>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CandidatePersonalInfo;
